<template>
  <v-footer
    class="bg-indigo-lighten-1 text-center d-flex flex-column"
  >
    <div>
        <span v-for="icon in social_media"  :key="icon">
        <v-tooltip :text="icon.name"    location="top" >
            <template v-slot:activator="{ props }">
                <!-- <a :href="icon.link" style="color:white" v-if="icon.fun">
                <v-btn
                 @click="copyPhoneNum"
                  v-bind="props"
                 :icon="icon.icon"
                 class="mx-4"
                 variant="text"
                ></v-btn>
                </a> -->
                 <a :href="icon.link" style="color:white" >
                <v-btn
               
                  v-bind="props"
                 :icon="icon.icon"
                 class="mx-4"
                 variant="text"
                ></v-btn>
                </a>
            </template>
</v-tooltip>
</span>
     
    </div>

    <div class="pt-0">
    للحجز و الاستعلام عن طريق الواتس اب او الاتصال بالتليفون 
      </div>

    <v-divider></v-divider>

    <div>
      <strong> <h4 dir="rtl">Phone Number: +1 (438)-877-4430  </h4></strong>
         <h4 >Email: October.arts@outlook.com </h4>
    </div>
       <div class="copyright">
        copyright © 2024 The m-hemdan web designer. All right reserved
    </div>
  

  </v-footer>
   
</template>
<script>
  export default {
    data: () => ({
      icons: [
        'mdi-facebook',
        'mdi-twitter',
        'mdi-linkedin',
        'mdi-instagram',
      ],
    }),
   
    computed:{
        social_media()
        {
            return this.$store.state.social_media
        }
    }
  }
</script>
<style scoped>
footer{
     border-radius: 10px 10px 0px 0px;
  
    bottom: 0;
    width: 100%;
    background:linear-gradient(90deg, rgba(42,40,67,1) 22%, rgba(46,52,62,1) 100%, rgba(0,212,255,1) 100%);
   
    }
.copyright{
    margin-top: 10px;
   border-radius: 10px 10px 10px 10px;
    background:  rgb(33,32,46);
  
    width: 100%;
}

</style>